<template>
  <page-section :title="$t('ProfilesEvents_Title')">
    <rest-list :payload="fetchEndpoint" :loading="!applicationsLoaded">
      <rest-list-column-date
        :prop="clickhouse ? 'timestamp' : 'create_time'"
        :unix="!clickhouse"
        :title="$t('ProfilesEvents_Field_Timestamp')"
        :width="200"
      />

      <rest-list-column
        :prop="clickhouse ? 'event_name' : 'event_title'"
        :title="$t('ProfilesEvents_Field_Title')"
        :sortable="false"
        :width="300"
      />

      <el-table-column :sortable="false" :min-width="300">
        <template slot="header" slot-scope="{}">
          <span>
            {{ $t('ProfilesEvents_Field_Properties') }}
          </span>
          <rest-list-filter-input :prop="propertiesField" />
        </template>
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            size="mini"
            v-if="isValidJson(scope.row[propertiesField])"
            @click="showDataPopup(scope.row[propertiesField])"
          >
            {{ $t('ProfilesEvents_JSON_Button_title') }}
            <el-icon name="view" />
          </el-button>
          <template v-else>{{ scope.row[propertiesField] }}</template>
        </template>
      </el-table-column>

      <rest-list-column-enum
        v-if="clickhouse"
        prop="source_channel"
        :title="$t('ProfilesEvents_Field_Channel')"
        :enum="AuditLogSource"
        :width="200"
        :sortable="false"
      />

      <rest-list-column-enum
        :prop="clickhouse ? 'source_application_id' : 'application_id'"
        :key="applicationsLoaded"
        :title="$t('ProfilesEvents_Field_Application')"
        :enum="applications"
        :width="200"
        :sortable="false"
      />

      <rest-list-column
        prop="device_id"
        :title="$t('ProfilesEvents_Field_Device')"
        :route="rowClickDeviceIdRoute"
        :width="200"
        :sortable="false"
      />

      <rest-list-column-date
        v-if="clickhouse"
        prop="received_at"
        :unix="false"
        :title="$t('ProfilesEvents_Field_ReceivedAt')"
        :width="200"
      />

      <rest-list-column-date
        v-if="clickhouse"
        prop="loaded_at"
        :unix="false"
        :title="$t('ProfilesEvents_Field_LoadedAt')"
        :width="200"
      />
    </rest-list>

    <el-dialog
      :title="$t('ProfilesEvents_JSON_Data_Title')"
      :visible="dataPopup"
      :modal="false"
      :modal-append-to-body="false"
      :before-close="closeDataPopup"
    >
      <vue-json-pretty :data="jsonData" class="json-wrapper" />
    </el-dialog>
  </page-section>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import VueJsonPretty from 'vue-json-pretty'
import RestListFilterInput from '@/common/components/rest/RestListFilterInput'
import PageSection from '@/common/components/page/PageSection'
import { RestApiPaginator } from '@/core/utils/RestApiPaginator'
import enquoteBigNumber from '@/common/helpers/JSONBigIntTransfromer'
import { AuditLogSource } from '@/modules/profiles/enum/AuditLog'

export default {
  name: 'EventsListPage',
  components: {
    PageSection,
    RestListFilterInput,
    RestListColumnDate,
    RestList,
    RestListColumnEnum,
    RestListColumn,
    VueJsonPretty
  },
  data() {
    return {
      dataPopup: false,
      jsonData: null,
      applications: {},
      applicationsLoaded: false,
      AuditLogSource
    }
  },
  created() {
    new RestApiPaginator(this.optionsEndpoint).fetchAllPages().then(data => {
      data.forEach(val => {
        this.applications[val.id] = val.name
      })
      this.applicationsLoaded = true
    })
  },

  methods: {
    showDataPopup(json) {
      this.jsonData = JSON.parse(enquoteBigNumber(json))
      this.dataPopup = true
    },
    closeDataPopup() {
      this.dataPopup = false
    },
    isValidJson(value) {
      try {
        if (JSON.parse(value)) {
          return true
        }
      } catch (e) {
        return false
      }
      return false
    },
    rowClickDeviceIdRoute(row) {
      return projectRoute({
        name: 'Device',
        query: {
          device_id: row.device_id
        }
      })
    }
  },

  computed: {
    clickhouse() {
      return this.$hasFeature('shouldReadEventsFromClickhouse')
    },
    propertiesField() {
      return this.clickhouse ? 'properties' : 'value'
    },
    optionsEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: 'applications',
        params: {}
      })
    },
    fetchEndpoint() {
      if (this.clickhouse) {
        return projectEndpoint({
          method: 'get',
          url: `event-hits-clickhouse`,
          params: {
            profile_id: this.$route.query.profile_id,
            sort: '-create_time'
          }
        })
      } else {
        return projectEndpoint({
          method: 'get',
          url: `event-hits`,
          params: {
            expand: 'event_title',
            profile_id: this.$route.query.profile_id,
            sort: '-timestamp'
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.json-wrapper {
  overflow-y: auto;
  max-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/pages/EventsListPage.vue